import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mt-auto" }
const _hoisted_2 = { class: "footer-top" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6 footer-left py-4 pe-4" }
const _hoisted_6 = { class: "d-flex justify-content-between mb-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/footer-logo.png",
  class: "main-logo",
  alt: "Picado"
}, null, -1)
const _hoisted_8 = { class: "list-inline d-flex mb-0 social-buttons" }
const _hoisted_9 = {
  key: 0,
  class: "list-inline-item mx-1"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-twitter" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "list-inline-item mx-1"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-instagram" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "list-inline-item mx-1"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook-f" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 3,
  class: "list-inline-item mx-1"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-8" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-6" }
const _hoisted_29 = { class: "list-unstyled" }
const _hoisted_30 = { class: "mb-2" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("About Us")
const _hoisted_32 = { class: "mb-2" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Our Team")
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = { class: "list-unstyled" }
const _hoisted_36 = { class: "mb-2" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Why Picado?")
const _hoisted_38 = { class: "mb-2" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Partners")
const _hoisted_40 = { class: "col-md-4 text-end app-buttons" }
const _hoisted_41 = {
  key: 0,
  class: "list-inline"
}
const _hoisted_42 = { class: "mb-2" }
const _hoisted_43 = ["href"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/footer-apple-store.png",
  height: "45"
}, null, -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["href"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/footer-google-play.png",
  height: "45"
}, null, -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-6 footer-right p-4\"><h6 class=\"fw-bold mb-4\">Subscribe to our newsletter</h6><p class=\"text-secondary\">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum.</p><div class=\"row\"><div class=\"col-9\"><input type=\"email\" placeholder=\"Email Address\" class=\"form-control material-control\"></div><div class=\"col-3\"><button type=\"button\" class=\"btn btn-primary btn-sm rounded-5 px-4 fw-bold\">Subscribe</button></div></div></div>", 1)
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-bottom bg-black text-white py-3\"><div class=\"container container-fluid\"><div class=\"row align-items-center\"><div class=\"col-md-6\"><a href=\"https://www.cocooncreations.net/\" target=\"_blank\"><img src=\"/images/power-by-cocoon.png\" alt=\"Cocoon Creations\"></a></div><div class=\"col-md-6\"><ul class=\"list-inline text-end mb-0\"><li class=\"list-inline-item me-3\"><a href=\"#\" class=\"text-white\">Terms &amp; conditions</a></li><li class=\"list-inline-item\"><a href=\"#\" class=\"text-white\">Privacy Policy</a></li></ul></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createElementVNode("ul", _hoisted_8, [
                (_ctx.social_links && _ctx.social_links.twitter)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                      _createElementVNode("a", {
                        href: _ctx.social_links.twitter,
                        target: "_blank"
                      }, _hoisted_12, 8, _hoisted_10)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.social_links && _ctx.social_links.instagram)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                      _createElementVNode("a", {
                        href: _ctx.social_links.instagram,
                        target: "_blank"
                      }, _hoisted_16, 8, _hoisted_14)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.social_links && _ctx.social_links.facebook)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                      _createElementVNode("a", {
                        href: _ctx.social_links.facebook,
                        target: "_blank"
                      }, _hoisted_20, 8, _hoisted_18)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.social_links && _ctx.social_links.communication_email)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                      _createElementVNode("a", {
                        href: 'mailto:' + _ctx.social_links.communication_email
                      }, _hoisted_24, 8, _hoisted_22)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("ul", _hoisted_29, [
                      _createElementVNode("li", _hoisted_30, [
                        _createVNode(_component_router_link, {
                          to: "/about-us",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_32, [
                        _createVNode(_component_router_link, {
                          to: "#",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_33
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("ul", _hoisted_35, [
                      _createElementVNode("li", _hoisted_36, [
                        _createVNode(_component_router_link, {
                          to: "#",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_37
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", _hoisted_38, [
                        _createVNode(_component_router_link, {
                          to: "#",
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_39
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                (_ctx.social_links)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_41, [
                      _createElementVNode("li", _hoisted_42, [
                        _createElementVNode("a", {
                          href: _ctx.social_links.ios_link,
                          class: "text-end",
                          target: "_blank"
                        }, _hoisted_45, 8, _hoisted_43)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: _ctx.social_links.android_link,
                          class: "text-end",
                          target: "_blank"
                        }, _hoisted_48, 8, _hoisted_46)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _hoisted_49
        ])
      ])
    ]),
    _hoisted_50
  ]))
}